import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../ui/SectionHeader';
import { CheckCircle2, Lock } from 'lucide-react';
const books = [{
  tag: 'T1',
  title: 'Las tareas sin batalla',
  subtitle: 'Cómo convertir la hora de estudiar en un momento de conexión y no de conflicto',
  desc: 'Entendé por qué tu hijo no es vago ni desobediente — es su cerebro. Aplicá una rutina paso a paso para hacer las tareas sin drama, con técnicas de bloques cortos que realmente funcionan y un protocolo claro para cuando se bloquea, llora o se niega.',
  bullets: ['Rutina de tareas paso a paso', 'Técnica de bloques cortos adaptada al TDAH', 'Protocolo para el bloqueo y la negativa']
}, {
  tag: 'T2',
  title: 'Cuando todo explota',
  subtitle: 'Cómo manejar las crisis emocionales sin perder la calma ni la conexión',
  desc: 'Aprendé a leer las señales antes de que todo escale, aplicá el protocolo de 4 pasos durante la crisis y sabé exactamente qué decir y qué NO decir en ese momento.',
  bullets: ['Señales de alerta antes de la crisis', 'Protocolo de 4 pasos para el momento crítico', 'Cómo reparar el vínculo después de la tormenta']
}, {
  tag: 'T3',
  title: 'El secreto de la concentración',
  subtitle: 'Estrategias reales para ayudar a tu hijo a enfocarse más allá de las tareas',
  desc: 'Descubrí por qué los métodos tradicionales no funcionan con tu hijo y aplicá estrategias concretas para sostener el foco en el día a día — sin reformar nada en tu casa.',
  bullets: ['Estrategias de foco adaptadas al cerebro con TDAH', 'Cómo adaptar el hogar para reducir distracciones', 'Fichas de juegos de atención por edad']
}, {
  tag: 'T4',
  title: 'Leer para entender',
  subtitle: 'Cómo ayudar a tu hijo a comprender lo que lee sin que sea una tortura para ninguno de los dos',
  desc: 'Entendé la diferencia entre leer y comprender, y aplicá técnicas de lectura adaptadas al cerebro con TDAH para acompañar sin terminar haciendo la tarea por él.',
  bullets: ['Técnicas de lectura adaptadas al TDAH', 'Fichas con preguntas guiadas por nivel de edad', 'Mapas mentales simples para organizar lo leído']
}, {
  tag: 'T5',
  title: 'Hablá con el colegio y que te escuchen',
  subtitle: 'Cómo defender los derechos de tu hijo en la escuela con argumentos reales y respaldo legal',
  desc: 'Conocé lo que la Ley 27.306 le exige al colegio, las 8 adaptaciones curriculares que podés pedir hoy mismo y qué hacer si la institución no cumple.',
  bullets: ['Las 8 adaptaciones curriculares que podés exigir', 'Modelo de carta listo para completar y enviar', 'Qué hacer cuando el colegio no responde']
}, {
  tag: 'T6',
  title: 'Hacé valer tus derechos con la obra social',
  subtitle: 'Todo lo que tu obra social tiene la obligación legal de cubrir y cómo reclamarlo si no lo hace',
  desc: 'Sabé exactamente qué dice la Ley 27.306 sobre cobertura obligatoria, cómo pedirla paso a paso y qué hacer cuando te dicen que no.',
  bullets: ['Qué prestaciones te tienen que cubrir sí o sí', 'Modelo de carta de reclamo lista para enviar', 'Checklist de documentación necesaria']
}, {
  tag: 'T7',
  title: 'Tu hijo pre-adolescente con TDAH',
  subtitle: 'Porque cuando llegan a los 11, 12 o 13 años todo cambia — y casi nadie habla de eso',
  desc: 'El tomo que las mamás de pre-adolescentes buscan y no encuentran. Autoestima, presión académica, pantallas, pares y resistencia a la autoridad — todo lo que cambia cuando el niño crece y el TDAH se transforma.',
  bullets: ['Cómo mantener la conexión cuando empieza a alejarse', 'Estrategias para la presión académica del secundario', 'Planilla de acuerdos y autonomía progresiva'],
  isPro: true
}, {
  tag: 'T8',
  title: 'Cuidarte para poder cuidarlo',
  subtitle: 'El tomo que nadie espera pero todas las mamás necesitan',
  desc: 'Porque no podés dar lo que no tenés. Culpa, frustración, límites, pedir ayuda y recarga mínima viable — acompañamiento real para la persona que sostiene todo.',
  bullets: ['Autodiagnóstico de bienestar parental', 'Checklist de señales de alerta del agotamiento emocional', 'Plan de recarga mínima viable sostenible'],
  isPro: true
}];
import { ChevronDown } from 'lucide-react';
export function Books() {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  return <section className="py-12 md:py-20 bg-[#FBF7F0]" data-id="element-47">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-48">
        <SectionHeader title="CONTENIDO COMPLETO — LOS 8 TOMOS" subtitle="Tu hoja de ruta para acompañar a tu hijo con TDAH sin agotarte" data-id="element-49" />

        <div className="grid md:grid-cols-2 gap-4 md:gap-8" data-id="element-50">
          {books.map((book, i) => {
          const isExpanded = expandedIndex === i;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className={`bg-white rounded-2xl shadow-sm border-2 transition-all duration-300 ${book.isPro ? 'border-[#E76F51]/30' : 'border-transparent'} overflow-hidden`} data-id="element-51">
                <div className="p-5 md:p-8 cursor-pointer md:cursor-default relative" onClick={() => {
              if (window.innerWidth < 768) {
                setExpandedIndex(isExpanded ? null : i);
              }
            }} data-id="element-52">
                  {book.isPro && <div className="absolute top-0 right-0 bg-[#E76F51] text-white text-[10px] md:text-xs font-bold px-2 md:px-4 py-1 rounded-bl-lg flex items-center gap-1" data-id="element-53">
                      <Lock size={10} data-id="element-54" />{' '}
                      <span className="hidden sm:inline" data-id="element-55">EXCLUSIVO</span> PRO
                    </div>}

                  <div className="flex items-center justify-between gap-4" data-id="element-56">
                    <div className="flex items-center gap-3 md:gap-4 flex-1" data-id="element-57">
                      <div className="bg-[#1E2A4A] text-white font-bold w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center text-lg md:text-xl shrink-0" data-id="element-58">
                        {book.tag}
                      </div>
                      <h3 className="text-lg md:text-2xl font-bold text-[#1E2A4A] leading-tight pr-4 md:pr-0" data-id="element-59">
                        {book.title}
                      </h3>
                    </div>
                    <div className="md:hidden shrink-0 text-[#1E2A4A]/40" data-id="element-60">
                      <ChevronDown className={`transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`} data-id="element-61" />
                    </div>
                  </div>

                  <div className={`mt-4 md:mt-4 overflow-hidden transition-all duration-300 md:!max-h-none md:!opacity-100 ${isExpanded ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0 md:max-h-full'}`} data-id="element-62">
                    <p className="text-[#E76F51] text-sm md:text-base font-semibold mb-3 md:mb-4 leading-snug" data-id="element-63">
                      {book.subtitle}
                    </p>

                    <p className="text-[#1E2A4A]/80 text-sm md:text-base mb-4 md:mb-6 leading-relaxed" data-id="element-64">
                      {book.desc}
                    </p>

                    <ul className="space-y-2 md:space-y-3" data-id="element-65">
                      {book.bullets.map((bullet, j) => <li key={j} className="flex items-start gap-2 md:gap-3" data-id="element-66">
                          <CheckCircle2 size={18} className="text-[#8A9A86] shrink-0 mt-0.5 md:w-5 md:h-5" data-id="element-67" />
                          <span className="text-[#1E2A4A] text-sm md:text-base font-medium" data-id="element-68">
                            {bullet}
                          </span>
                        </li>)}
                    </ul>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}